export default __webpack_public_path__ + "static/media/iims_jun_logo.9f98114e.png";